module.exports = __webpack_public_path__ + "static/media/04_gazetanoticias.c2ef1c49.jpg";